<template>
  <div id="search">
    <span id="searched-model">
      <h2>{{ search }}</h2>
      <Model :background="searchfor.background" :rotationSpeed="0" :transformation="null" />
    </span>
  </div>
</template>

<script>
const Model = () => import('./Model.vue')
// import Model from './Model.vue'

export default {
  name: 'SearchModal',
  components:{
    Model
  },
  props: {
    searchfor: Object
  },
  data: function(){
    return {
      search: window.config.text.searchModal.text
    }
  }
}
</script>
